import {helpers, required} from "@vuelidate/validators";
export class ConsumerComplaintProviderModel {
    constructor(data = {}) {
        this.providerId = data.providerId ?? null;
        this.complaintId = data.complaintId ?? null;
        this.name = data.name ?? '';
        this.phoneNumber = data.phoneNumber ?? '';
        this.serviceDateFrom = data.serviceDateFrom ?? null;
        this.serviceDateTo = data.serviceDateTo ?? null;
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
    }

    static getValidationRules() {
        return {
            name: {required: helpers.withMessage('Provider Name is required', required)},
            phoneNumber: {required: helpers.withMessage('Provider Phone Number is required', required)},
            serviceDateFrom: {required: helpers.withMessage('Consumer Complaint - Provider Service Start Date is required', required)},
            serviceDateTo: {required: helpers.withMessage('Consumer Complaint - Provider Service End Date is required', required)}
        };
    }
}